import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router';
import { Box } from 'reflexbox';

import { ArrowLeftIcon } from '@treams/treams-icons';
import * as graphql from '@treams/treams-network';
import {
	Author,
	Button,
	Container,
	PAGE_CONTENT_WIDTH,
	Paragraph,
	TextBubble,
	Title,
	Toolbar,
} from '@treams/treams-ui';

import { CommentsWithData } from '../comments/Comments';
import CommentBar from '../comments/components/CommentBar';

export default function Compliment() {
	const { t } = useTranslation();

	const [composer, setComposer] = useState(false);

	const { params } = useRouteMatch<{ userID?: string; id: string }>();
	const { userID, id } = params;

	const query = graphql.useComplimentQuery({ variables: { id } });

	return (
		<Container py={4} wide={PAGE_CONTENT_WIDTH}>
			<Toolbar>
				<Button
					icon={<ArrowLeftIcon />}
					link={userID ? `/users/${userID}/feedback/compliments` : '/feedback/compliments'}
					title={t('goals.show.toolbar.back')}
					type="tertiary"
					ml="-12px"
				/>
			</Toolbar>

			<Box mt={4}>
				{query.data ? (
					<>
						<Title mb={3}>
							{query.data.compliment.sender.isViewer
								? t('compliment.detail.outgoingTitle', {
										name: query.data.compliment.recipient.firstName,
									})
								: t('compliment.detail.title', { name: query.data.compliment.sender.firstName })}
						</Title>

						<CommentBar.Container
							onComment={() => setComposer((composer) => !composer)}
							targetID={id}
							targetType={graphql.CommentTargetType.Compliment}
							enabled={query.data.compliment.recipient.__typename === 'User'}
							onRefetch={() => query.refetch()}
						>
							<TextBubble user={query.data.compliment.sender} text={query.data.compliment.text} />
						</CommentBar.Container>

						<CommentsWithData
							empty={false}
							composer={composer}
							comments={query.data.compliment.comments}
							autoFocus
							target={query.data.compliment}
							onCancelComposer={() => setComposer(false)}
							onRefetch={() => query.refetch()}
						/>
					</>
				) : (
					<>
						<Title.Skeleton mb={3} />
						<Paragraph.Skeleton mb={3} />
						<Author.Skeleton />
					</>
				)}
			</Box>
		</Container>
	);
}
